import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CityDialog',
  props: {
    userInfo: {
      type: Object,
      default: function _default() {}
    },
    areaGradeInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      areaValue: [],
      areaOptions: []
    };
  },
  mounted: function mounted() {
    this.getAreaAndGrade();
    this.areaValue = [this.userInfo.province];

    if (this.userInfo.city) {
      this.areaValue.push(this.userInfo.city);
    }

    if (this.userInfo.area) {
      this.areaValue.push(this.userInfo.area);
    }
  },
  methods: {
    getAreaAndGrade: function getAreaAndGrade() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var areaInfo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                areaInfo = _this.areaGradeInfo.areaInfo;

                _this.dealArea(areaInfo);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dealArea: function dealArea(areaInfo) {
      var _this2 = this;

      var areaOptions = areaInfo.map(function (item) {
        var obj = {
          value: item.code,
          label: item.name
        }; // 处理学段key

        if (item.gradeInfo && item.gradeInfo.length > 0) {
          obj.options = _this2.dealKey(item.gradeInfo);
        } // 处理区域key


        if (item.entities && item.entities.length > 0) {
          obj.children = _this2.dealKey(item.entities);
        }

        return obj;
      });
      this.areaOptions = areaOptions;
    },
    dealKey: function dealKey(arr) {
      var _this3 = this;

      return arr.map(function (item) {
        var obj = {
          value: item.id || item.code,
          label: item.name
        }; // 处理学段key

        if (item.gradeInfo && item.gradeInfo.length > 0) {
          obj.options = _this3.dealKey(item.gradeInfo);
        } // 处理区域key


        if (item.entities && item.entities.length > 0) {
          obj.children = _this3.dealKey(item.entities);
        }

        return obj;
      });
    },
    saveCity: function saveCity() {
      this.$attrs.close({
        province: this.areaValue[0],
        city: this.areaValue.length > 1 ? this.areaValue[1] : 0,
        area: this.areaValue.length > 2 ? this.areaValue[2] : 0
      });
    }
  }
};